import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';
import { Helmet } from 'react-helmet';
import Header from './Header/Header';
import Banner from './Header/Banner';
import { staticFiles, staticCache, privacyPolicy, pagesToNotIndex } from '../../config';
import translateFileUrl from '../../services/Auth/translateFileUrl';
import { t } from './Translate';
import SubHeader from './Header/SubHeader';
import { Auth } from '../../config/configuration/react';

const Content = (props) => {
  const { match } = props;
  const { contentSlug } = match.params;
  const isNoIndexed = pagesToNotIndex.includes(contentSlug);
  const contentDiv = useRef(null);

  const getContent = async (key) => {
    let language = Auth.preferredLanguage();
    if (language === undefined) language = process.env.REACT_APP_LANG;
    const cache = await caches.open(staticCache);
    let cacheContent;
    if (contentSlug === 'privacyPolicy')
      cacheContent = await cache.match(translateFileUrl(language, privacyPolicy[language.toUpperCase()]));
    else cacheContent = await cache.match(translateFileUrl(language, staticFiles[key]));
    if (contentSlug === 'privacyPolicy' && cacheContent === undefined)
      cacheContent = await cache.match(translateFileUrl('fr', privacyPolicy.default));
    else if (cacheContent === undefined) return '';
    return cacheContent?.text();
  };

  useEffect(() => {
    if (Object.prototype.hasOwnProperty.call(staticFiles, contentSlug) || contentSlug === 'privacyPolicy') {
      getContent(contentSlug).then((cacheContent) => {
        contentDiv.current.innerHTML = cacheContent;
      });
    }
  }, [contentSlug]);

  // const content = _.find(contentList, { slug: contentSlug });

  const translations = {
    contact: t('contact_us'),
    help: t('help'),
    infos: t('infos'),
    privacyPolicy: t('privacyPolicy'),
  };

  return (
    <>
      {isNoIndexed && (
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
      )}
      <Header {...props} title={translations[contentSlug]} />
      <Banner />
      <SubHeader {...props} title={translations[contentSlug]} />
      <Container fluid>
        <Row>
          <Col>
            <div className="content-body" ref={contentDiv} />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Content;

Content.propTypes = {
  match: PropTypes.shape().isRequired,
};
